import type { SelectAddressEvent } from '~/composables/useNewSearchSuggest';
import type { MacroregionName } from '~/config/cities';

import { usePropertySearchStateKey } from '~/composables/propertySearch/context';

interface TwoFieldSearchSuggestState {
	firstFieldSelection: SelectAddressEvent | null;
	firstFieldSearchTerm: string;
	secondFieldSearchTerm: string;
	selectedMacroregion?: MacroregionName | (string & {}); // workaround to keep type inference
}

/**
 * Lightweight composable that manages shared search suggest state
 * Uses a single useState to ensure a single instance across the entire application
 * This is the canonical source of truth for search suggest state
 */
export function useTwoFieldSearchSuggestState() {
	// Single state object containing all search suggest state
	const state = useState<TwoFieldSearchSuggestState>(
		usePropertySearchStateKey('searchSuggest-state'),
		() => ({
			firstFieldSelection: null,
			firstFieldSearchTerm: '',
			secondFieldSearchTerm: '',
			selectedMacroregion: undefined
		})
	);

	// Expose individual properties as reactive refs for easy destructuring
	return {
		firstFieldSelection: computed({
			get: () => state.value.firstFieldSelection,
			set: value => {
				state.value.firstFieldSelection = value;
			}
		}),
		firstFieldSearchTerm: computed({
			get: () => state.value.firstFieldSearchTerm,
			set: value => {
				state.value.firstFieldSearchTerm = value;
			}
		}),
		secondFieldSearchTerm: computed({
			get: () => state.value.secondFieldSearchTerm,
			set: value => {
				state.value.secondFieldSearchTerm = value;
			}
		}),
		selectedMacroregion: computed({
			get: () => state.value.selectedMacroregion,
			set: value => {
				state.value.selectedMacroregion = value;
			}
		})
	};
}
